import React from 'react'

const SquareButton = (props) => {
    return (
        <button className={"c-btn-"+props.type}
                type="submit"
                onClick={() => props.onClick()}>{props.text}</button>
    )
};

export default SquareButton
